import _ from "lodash";

export interface Option {
    id: number;
    name: string;
    position?: number;
    is_user_created?: boolean;
    available_for_notifications?: boolean;
    classes?: string;
}

export namespace Option {
    export enum EListParamType {
        "journal_entry_object" = 1,
        "type_client" = 20,
        "role_contact" = 21,
        "category_client" = 22,
        "materiel_categorie" = 40,
        "materiel_emplacement" = 41,
    }

    export function toTag(o: Option) {
        return {
            id: o.id,
            text: o.name,
            classes: o.classes,
        };
    }

    export function toTags(options: Array<Option>) {
        return _.map(options, function (o) {
            return Option.toTag(o);
        });
    }

    export function arrToOptions(options: Option[]) {
        return _.keyBy(options, "id");
    }
}
